"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.typed.uint8-array");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _xlsx = _interopRequireDefault(require("xlsx"));
var _default = exports.default = {
  methods: {
    readExcelFileToJson: function () {
      var _readExcelFileToJson = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file) {
        var excelData;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              excelData = null;
              _context.n = 1;
              return new Promise(function (resolve, reject) {
                try {
                  var reader = new FileReader();
                  reader.onload = function () {
                    try {
                      var fileData = new Uint8Array(reader.result);
                      var workbook = _xlsx.default.read(fileData, {
                        type: 'array',
                        cellDates: true
                      });
                      if (workbook.SheetNames.length === 0) {
                        resolve(null);
                        return;
                      }
                      var firstSheetName = workbook.SheetNames[0];
                      var rows = _xlsx.default.utils.sheet_to_json(workbook.Sheets[firstSheetName], {
                        raw: true
                      });
                      resolve(rows);
                    } catch (e) {
                      reject(e);
                    }
                  };
                  reader.readAsArrayBuffer(file);
                } catch (e) {
                  reject(e);
                }
              }).then(function (result) {
                excelData = result;
              }).catch(function (error) {
                console.log(error);
              });
            case 1:
              return _context.a(2, excelData);
          }
        }, _callee);
      }));
      function readExcelFileToJson(_x) {
        return _readExcelFileToJson.apply(this, arguments);
      }
      return readExcelFileToJson;
    }()
  }
};